var _excluded = ["borderTop"],
    _excluded2 = ["children", "borderBottom", "borderTop", "contentPadding"];

var _templateObject, _templateObject2;

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import React from "react";
import styled, { css } from "styled-components";
import ExpanderGroup from "@nib-components/expander-group";
import AccordionItem from "./AccordionItem";
import { BORDER_VALUE } from "./utils";
var AccordionExpanderGroup = styled(function (_ref // eslint-disable-line no-unused-vars
) {
  var borderTop = _ref.borderTop,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(ExpanderGroup, props);
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n"])), function (_ref2) {
  var borderTop = _ref2.borderTop;
  return borderTop && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      border-top: ", ";\n    "])), BORDER_VALUE);
});

var Accordion = function Accordion(props) {
  var children = props.children,
      borderBottom = props.borderBottom,
      borderTop = props.borderTop,
      contentPadding = props.contentPadding,
      otherprops = _objectWithoutProperties(props, _excluded2);

  return /*#__PURE__*/React.createElement(AccordionExpanderGroup, _extends({
    borderTop: borderTop
  }, otherprops), React.Children.map(children, function (child) {
    if ( /*#__PURE__*/React.isValidElement(child)) {
      return /*#__PURE__*/React.cloneElement(child, {
        borderBottom: borderBottom
      });
    }

    return null;
  }));
};

Accordion.defaultProps = {
  borderTop: false,
  borderBottom: true
};
Accordion.displayName = "Accordion";
Accordion.Item = AccordionItem;
export default Accordion;